"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ViewportContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ViewportContext = _react.default.createContext();

exports.ViewportContext = ViewportContext;

var ViewportProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ViewportProvider, _React$Component);

  function ViewportProvider(props) {
    var _this;

    _classCallCheck(this, ViewportProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ViewportProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getViewportMatch", function () {
      for (var breakpoint in _breakpoints.default) {
        var _BREAKPOINTS$breakpoi = _breakpoints.default[breakpoint],
            min = _BREAKPOINTS$breakpoi.min,
            max = _BREAKPOINTS$breakpoi.max;
        if (window.innerWidth >= min && window.innerWidth <= max) return breakpoint;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function () {
      var newViewport = _this.getViewportMatch();

      if (newViewport !== _this.state.viewport) _this.setState({
        viewport: newViewport
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateStateCallback", (0, _lodash.default)(_this.updateState, 200));

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.updateStateCallback();
    });

    _this.state = {
      viewport: _this.getViewportMatch()
    };
    return _this;
  }

  _createClass(ViewportProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, true);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var viewport = this.state.viewport;
      return _react.default.createElement(ViewportContext.Provider, {
        value: viewport
      }, children);
    }
  }]);

  return ViewportProvider;
}(_react.default.Component);

ViewportProvider.propTypes = {
  children: _propTypes.node.isRequired
};
var _default = ViewportProvider;
exports.default = _default;
ViewportProvider.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getViewportMatch",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateState",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleResize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "ViewportProvider",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};